// Display helpers shared by the pages: relative time, durations, timestamps.

export function relativeTime(iso: string | null | undefined): string {
  if (!iso) return "—";
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return "—";
  const diff = Date.now() - then;
  const abs = Math.abs(diff);
  const min = 60_000;
  const hr = 60 * min;
  const day = 24 * hr;
  const pick = (): string => {
    if (abs < min) return "just now";
    if (abs < hr) return `${Math.round(abs / min)}m`;
    if (abs < day) return `${Math.round(abs / hr)}h`;
    if (abs < 30 * day) return `${Math.round(abs / day)}d`;
    return new Date(iso).toLocaleDateString();
  };
  const label = pick();
  if (label === "just now") return label;
  return diff >= 0 ? `${label} ago` : `in ${label}`;
}

/** Wall time between two instants; a null end means "still running" and
 * measures against now. */
export function duration(
  startIso: string | null,
  endIso: string | null,
): string {
  if (!startIso) return "—";
  const start = new Date(startIso).getTime();
  const end = endIso ? new Date(endIso).getTime() : Date.now();
  if (Number.isNaN(start) || Number.isNaN(end) || end < start) return "—";
  const secs = Math.round((end - start) / 1000);
  if (secs < 60) return `${secs}s`;
  const m = Math.floor(secs / 60);
  const s = secs % 60;
  if (m < 60) return s ? `${m}m ${s}s` : `${m}m`;
  const h = Math.floor(m / 60);
  return `${h}h ${m % 60}m`;
}

/** Compact timestamp: first 16 chars of ISO, `T`→space (`2026-07-01 14:16`). */
export function shortStamp(iso: string | null | undefined): string {
  if (!iso) return "—";
  return iso.slice(0, 16).replace("T", " ");
}
